/**
 * Club map bootstrap: one club GET (optional) plus layer lists in parallel.
 * Client-side filters stay because the backend may ignore query params.
 */

export function filterClubBoundaries(raw, clubMapId) {
  const rows = Array.isArray(raw) ? raw : [];
  if (clubMapId == null) return rows;
  return rows.filter((b) => Number(b.club_map) === Number(clubMapId));
}

export function filterClubLocations(raw, boundaryIds) {
  const rows = Array.isArray(raw) ? raw : [];
  if (!boundaryIds || boundaryIds.size === 0) return [];
  return rows.filter((loc) => boundaryIds.has(loc.hunt_boundary));
}

export function filterClubSharedLines(raw) {
  const rows = Array.isArray(raw) ? raw : [];
  return rows.filter(
    (f) => (f.type === 'line' || f.type === 'LineString') && f.geojson?.type === 'LineString',
  );
}

function clubPayload(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
  return data;
}

export async function loadClubMapLayers(api, clubId, { clubMapId } = {}) {
  if (!clubId) {
    return { club: null, clubMapId: null, boundaries: [], locations: [], lines: [] };
  }
  if (!api || typeof api.get !== 'function') {
    throw new Error('api client required');
  }

  const needClub = clubMapId == null;
  const [clubRes, boundariesRes, locationsRes, featuresRes] = await Promise.all([
    needClub ? api.get(`/clubs/${clubId}/`) : Promise.resolve({ data: null }),
    api.get(`/hunt-boundaries/?club_map__club=${clubId}`),
    api.get(`/hunt-locations/?hunt_boundary__club_map__club=${clubId}`),
    api.get(`/features/?share_type=club&shared_with_club=${clubId}`),
  ]);

  const club = clubPayload(clubRes?.data);
  const resolvedMapId = clubMapId ?? club?.map?.id ?? null;
  const boundaries = filterClubBoundaries(boundariesRes?.data, resolvedMapId);
  const locations = filterClubLocations(
    locationsRes?.data,
    new Set(boundaries.map((b) => b.id)),
  );
  const lines = filterClubSharedLines(featuresRes?.data);

  return { club, clubMapId: resolvedMapId, boundaries, locations, lines };
}
